import script from "./InformationCardField.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationCardField.vue?vue&type=script&lang=ts&setup=true"

import "./InformationCardField.vue?vue&type=style&index=0&id=3cb882ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb882ec"]])

export default __exports__